import {searchModel} from "../../Utilities/Search";
import {STUDENT_APPROVAL_STATUS_FOR_SEARCH} from "./studentConstants";

export const studentSearchModel = (studentId = "", fimcStudentId = "", studentName = "", dateOfBirth = "", dateCreatedUtc="", dateModifiedUtc="", gradeLevel = "", districtId = "", patronName = "", educationalFacility = "", studentApprovalStatus = `${STUDENT_APPROVAL_STATUS_FOR_SEARCH.PendingNeedInfo.id}`, studentStatus = "", studentInactiveReason = "", organization = "") => {
    return Object.assign({}, searchModel(studentId.toString(),"fullName", false, "fullName"), {
        studentName,
        fimcStudentId ,
        dateOfBirth,
        dateCreatedUtc,
        dateModifiedUtc,
        gradeLevel,
        districtId,
        patronName,
        educationalFacility,
        studentApprovalStatus,
        studentStatus,
        studentInactiveReason,
        organization,
        ClearStudentSearch: clearStudentSearch,
    });
};

function clearStudentSearch(this: Record<string, unknown>) {
    this.studentName = "";
    this.fimcStudentId = "";
    this.dateOfBirth = "";
    this.gradeLevel = "";
    this.districtId = "";
    this.patronName = "";
    this.educationalFacility = "";
    this.studentApprovalStatus = "";
    this.studentStatus = "";
    this.studentInactiveReason = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}
